module.exports = __webpack_public_path__ + "img/shop.c6d721cf.svg";